module.exports = __webpack_public_path__ + "static/media/eco-retail.36d6e123.svg";